import React from 'react'
import styled from 'styled-components';
import BooksitoutIcon from "../../../config/BooksitoutIcon";

interface Props {
    message: string
}

const BookSourceNoContent: React.FC<Props> = ({message}) => {
    return (
        <Container>
            <IconContainer>
                <BooksitoutIcon.bookXmark/>
            </IconContainer>

            <MessageContainer>
                {message}
            </MessageContainer>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    text-align: center;

    color: var(--text-color);
    
    &:hover {
        color: var(--text-color);
    }
`

const IconContainer = styled.span`
    font-size: 50px;
`

const MessageContainer = styled.h5`
    font-weight: bold;
`

export default BookSourceNoContent